import React, { useState } from 'react';
import { router } from '@inertiajs/react';
import SignupLayout from '../Layout.jsx';
import SelectableCard from '../../../components/SelectableCard.jsx';
import { FACILITY_TYPES } from '../../../constants/facilityTypes.js';
import { primaryBtnClass, secondaryBtnClass, saveDraftPatch } from '../shared.jsx';

export default function IndividualFacility({ role, facility_type: initialFacilityType, progress }) {
  const [facilityType, setFacilityType] = useState(initialFacilityType || '');
  const [submitting, setSubmitting] = useState(false);

  const handleContinue = async () => {
    if (!facilityType || submitting) return;
    setSubmitting(true);
    await saveDraftPatch({ individual: { facility_type: facilityType } });
    router.visit('/signup/individual/review');
  };

  const isAdmin = role === 'Administrator';

  return (
    <SignupLayout progress={progress} maxWidth="sm:max-w-2xl">
      <div className="space-y-4">
        <div className="text-center space-y-2">
          <h2 className="text-2xl/9 font-bold tracking-tight text-gray-900">
            {isAdmin ? 'What type of facility do you administer?' : 'Which facility type are you associated with?'}
          </h2>
          {isAdmin && (
            <p className="text-sm text-gray-500">We'll tailor your Title 22 track to match.</p>
          )}
        </div>
        <fieldset className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-6">
          {FACILITY_TYPES.map((ft) => (
            <SelectableCard key={ft.value} name="facility_type" value={ft.value}
              checked={facilityType === ft.value} onChange={() => setFacilityType(ft.value)}
              inputMarginTop="mt-1.5">
              <span className="block text-xl font-bold text-gray-900">{ft.abbr}</span>
              <span className="block text-sm font-semibold text-gray-900 mt-1">{ft.name}</span>
              <span className="block text-sm text-gray-500 mt-1">{ft.description}</span>
            </SelectableCard>
          ))}
        </fieldset>
        <div className="flex gap-3 mt-6">
          <button type="button" onClick={() => router.visit('/signup/individual/training')} className={`${secondaryBtnClass} flex-1`}>Back</button>
          <button type="button" onClick={handleContinue} disabled={!facilityType || submitting} className={`${primaryBtnClass} flex-1`}>Continue</button>
        </div>
      </div>
    </SignupLayout>
  );
}
